/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserListResponse } from '../../models/user-list-response';

export interface GetUsers$Params {

/**
 * Page number (0-based).
 */
  page?: number;

/**
 * Number of items per page (max 100).
 */
  size?: number;

/**
 * Sorting criteria in the format: property(:asc|desc). Default is 'createdAt:asc'. Multiple sort criteria are supported.
 */
  sort?: Array<string>;

/**
 * Search term for email, first name, or last name.
 */
  search?: string;

/**
 * Filter by user status (ACTIVE, BLOCKED, INACTIVE, ALL). Default is ACTIVE.
 */
  status?: 'ACTIVE' | 'BLOCKED' | 'INACTIVE' | 'ALL';
}

export function getUsers(http: HttpClient, rootUrl: string, params?: GetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<UserListResponse>> {
  const rb = new RequestBuilder(rootUrl, getUsers.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('search', params.search, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserListResponse>;
    })
  );
}

getUsers.PATH = '/api/v2/users';
